export default {
  textView: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};
